import React, { Component } from 'react';
import { Row, Col, Icon } from '$common';
import CSSModules from 'react-css-modules';
import style from './notification.scss';
import cx from 'classnames';

const iconMap = {
  success: 'check',
  error: 'cross',
  warning: 'info'
};

@CSSModules(style, { allowMultiple: true })
export default class Notification extends Component {
  componentDidMount() {
    setTimeout(this.props.onClose, 3000);
  }

  render() {
    const { message, type } = this.props.notification;
    const { onClose } = this.props;

    const classes = cx({
      message: true,
      [`type-${type}`]: true
    });

    return (
      <div styleName="root">
        <div styleName={classes}>
          <Row>
            <Col sm="1/8" vertical="center">
              <Icon name={iconMap[type]} />
            </Col>
            <Col sm="6/8" vertical="center">
              {message}
            </Col>
            <Col sm="1/8" vertical="center">
              <a onClick={onClose}>Hide</a>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/root/notification.js